var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',[_c('v-select',{attrs:{"value":_vm.location,"items":_vm.formattedLocations,"item-text":"textToShow","item-value":"id","label":"Course configuration"},on:{"input":function($event){return _vm.$emit('update:location', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }